import {
  serviceSSO,
  trainingServe,
  SysToken,
  ServiceCandidate,
  notificationAuth,
  publicService,
  prefRequest,
  ServiceCandidateParser,
  KeynodeService,
  getProcessedToken,
  serviceRecruitment,
  requestSuggestion,
} from "./request";
import { hasAccess } from "./tokenCheck";

export const conVerter = (data) => {
  return serviceRecruitment({
    url: "rep/resume-clinic-download/",
    method: "POST",
    responseType: "blob",
    data,
  });
};

// Calling token API
export const userLogin = (data, headers) => {
  return KeynodeService({
    url: `token`,
    method: "post",
    headers: headers,
    data,
  });
};
export const userLogOut = (data, headers) => {
  return serviceSSO({
    url: `auth/realms/SimplifyCV/protocol/openid-connect/logout`, //SimplifyCV hire3x-dev
    method: "post",
    headers: headers,
    data,
  });
};

// Sign In
export const signIn = (data) => {
  return trainingServe({
    url: `candidate/authentication/?email=${data}`,
    method: "get",
  });
};

// Register
export const register = (data) => {
  return trainingServe({
    url: `candidate/authentication/`,
    method: "post",
    data,
  });
};

// Forgot Password?
export const forgotPassword = (email) => {
  return SysToken({
    url: `forgot-password/?email=${email}`,
    method: "get",
  });
};

//All Market Place Courses
export const getMaketPlace = (data) => {
  return trainingServe({
    url: `marketplace/courses/`,
    method: "post",
    data,
  });
};

//For getting Stars and instructor info Of each category
export const getMaketPlaceCategory = (data) => {
  return trainingServe({
    url: `marketplace/courses/`,
    method: "post",
    data,
  });
};
// For getting course Stats
export const getcourseStats = (payload) => {
  return trainingServe({
    url: `candidate/course-stats/`,
    method: "get",
    params: {
      courseID: payload.courseID,
    },
  });
};

//Get all the Popular Categories List
export const getPopularCategories = (payload) => {
  return trainingServe({
    url: `hire3x/categories`,
    method: "get",
    params: {
      count: payload.count,
      searchQuery: payload.searchQuery,
      courseCountRequired: payload.courseCountRequired,
      popularCategories: payload.popularCategories,
    },
  });
};

export const getFeaturedCategories = (payload) => {
  return trainingServe({
    url: `hire3x/categories`,
    method: "get",
    params: {
      count: payload.count,
      searchQuery: payload.searchQuery,
      featuredCategories: payload.featuredCategories,
      page: payload.page,
    },
  });
};

//for getting course instructor details
export const getCourseInstructor = (data) => {
  return trainingServe({
    url: `marketplace/instructor-info/`,
    method: "get",
    params: {
      instructorUserID: data,
    },
  });
};

//for getting course ratings
export const getCourseRatings = (data) => {
  return trainingServe({
    url: `marketplace/rating/`,
    method: "get",
    params: {
      referenceID: data.referenceID,
      count: data.count,
      page: data.page,
      // getSummaryInfo: true,
    },
  });
};
export const publicUserData = (code) => {
  return trainingServe({
    url: "candidate/certificate-hash/?certificateHash=" + code,
    method: "get",
  });
};
//for getting particular course details
export const getParticularCourseDetails = (data) => {
  return trainingServe({
    url: `marketplace/preview-course/`,
    method: "post",
    data,
  });
};

// Add to wishlist
export const addtoWishlist = (data) => {
  return trainingServe({
    url: `marketplace/wishlist/`,
    method: "post",
    data,
  });
};

// get all wishlist data in wishlist page
export const getAllWishlist = (data) => {
  return trainingServe({
    url: `marketplace/wishlist/`,
    method: "get",
    params: {
      count: data.count,
      page: data.page,
    },
  });
};

// remove wishlist
export const removetoWishlist = (data) => {
  return trainingServe({
    url: `marketplace/wishlist/`,
    method: "delete",
    data,
  });
};

//for liking and disliking the reviews
export const likeDislike = (data) => {
  return trainingServe({
    url: `marketplace/rating/`,
    method: "put",
    data,
  });
};

export const addToCartPost = (data) => {
  return trainingServe({
    url: `marketplace/cart/`,
    method: "post",
    data,
  });
};

export const getAllCart = () => {
  return trainingServe({
    url: `marketplace/cart/`,
    method: "get",
  });
};

export const removeCart = (data) => {
  return trainingServe({
    url: `marketplace/cart/`,
    method: "delete",
    data,
  });
};

// get all section Without Content
export const getCourseInfoWithSections = (data) => {
  return trainingServe({
    url: `candidate/preview-course/?courseID=${data.courseID}&isSectionsRequired=true`,
    method: "get",
  });
};

// get specific lesson details and content
export const getLessonWithContent = (data) => {
  return trainingServe({
    url: `/candidate/preview-course/?courseID=${data.courseID}&lessonInfo=true&lessonID=${data.lessonID}`,
    method: "get",
  });
};

// Lesson Completion Log
export const completeLesson = (data) => {
  return trainingServe({
    url: `candidate/lesson-completion-controller/`,
    method: "post",
    data,
  });
};

export const getCourseDetails = (data) => {
  return trainingServe({
    url: `candidate/my-course/`,
    method: "post",
    data,
  });
};
export const getAuthors = (data) => {
  return trainingServe({
    url: `candidate/my-course/?author=true&searchQuery=${data.searchQuery}&page=${data.page}&count=${data.count}`,
    method: "get",
    data,
  });
};
export const getCategories = (data) => {
  return trainingServe({
    url: `candidate/my-course/?category=true&searchQuery=${data.searchQuery}&page=${data.page}&count=${data.count}`,
    method: "get",
    data,
  });
};

// starting the quiz
export const startQuiz = (data) => {
  return trainingServe({
    url: `quiz/quiz-response/`,
    method: "post",
    data,
  });
};

// get the quiz questions
export const getQuiz = (data) => {
  return trainingServe({
    url: `quiz/quiz-response/?responseID=${data}`,
    method: "get",
    data,
  });
};

// answer the quiz questions
export const answerQues = (data) => {
  return trainingServe({
    url: `quiz/quiz-response/`,
    method: "put",
    data,
  });
};

// submit the quiz
export const submitQuiz = (data) => {
  return trainingServe({
    url: `quiz/quiz-marking/`,
    method: "post",
    data,
  });
};

// get the quiz questions with result
export const getQuizResult = (data) => {
  return trainingServe({
    url: `quiz/quiz-marking/?responseID=${data}`,
    method: "get",
    data,
  });
};
export const setReminder = (data) => {
  return trainingServe({
    url: `candidate/course-reminder/`,
    method: "post",
    data,
  });
};
// get cart summary
export const getCartSummary = (promo) => {
  const summary = {
    url: `marketplace/cart-summary/`,
    method: "get",
  };
  if (promo) {
    summary["params"] = {
      promoCode: promo,
    };
  }
  return trainingServe(summary);
};

//verify Coupon
export const getVerifyCoupon = (data) => {
  return trainingServe({
    url: `marketplace/coupon-verify/`,
    method: "get",
    params: {
      promoCode: data.promoCode,
    },
  });
};
export const getoverallProgress = () => {
  return trainingServe({
    url: `candidate/overall-progress-controller/`,
    method: "post",
  });
};
export const getcandidateInfo = () => {
  return trainingServe({
    url: `/candidate/candidate-info/`,
    methods: "post",
  });
};

//search history
export const getSearchHistory = (data) => {
  return trainingServe({
    url: `marketplace/candidate-course-logs/`,
    method: "get",
    params: data,
  });
};

//remove search history
export const removeSearchHistory = (data) => {
  return trainingServe({
    url: `marketplace/candidate-course-logs/`,
    method: "delete",
    data,
  });
};

//Certificates APIs
export const getOngoingCourses = (data) => {
  return trainingServe({
    url: "candidate/my-course/",
    method: "post",
    data: {
      completed: false,
      sortBy: "progress",
      order: -1,
      page: data.page,
      count: data.count,
    },
  });
};

export const getCompletedCourses = () => {
  return trainingServe({
    url: "candidate/my-course/",
    method: "post",
    data: {
      completed: true,
    },
  });
};

export const addCourseToWishlist = (courseID) => {
  return trainingServe({
    url: `marketplace/wishlist/`,
    method: "post",
    data: {
      itemID: courseID,
    },
  });
};

export const removeCourseFromWishlist = (courseID) => {
  return trainingServe({
    url: `marketplace/wishlist/`,
    method: "delete",
    data: {
      itemID: courseID,
    },
  });
};

export const getPublicCertificate = (data) => {
  return trainingServe({
    url: `candidate/public-candidate-certificate/`,
    method: "get",
    params: data,
  });
};

export const previewCourse = (data) => {
  return trainingServe({
    url: `marketplace/preview-course/`,
    method: "post",
    data,
  });
};

//get search for courses and instructors
export const getSearch = (data) => {
  return trainingServe({
    url: `marketplace/top-search/?searchQuery=${data}`,
    method: "get",
  });
};

// get course counts
export const getCourseCounts = (data) => {
  return trainingServe({
    url: `common/course-counts/?courseID=${data}`,
    method: "get",
  });
};

//get sub-categories
export const getSubCategories = (data) => {
  return trainingServe({
    url: `hire3x/categories`,
    method: "get",
    params: data,
  });
};

// get threads
export const getThreads = (data) => {
  return trainingServe({
    url: `community/thread-controller/`,
    method: "get",
    params: {
      referenceID: data.courseID,
      count: data.count,
      page: data.page,
      searchQuery: data.searchQuery,
      getCommentsInfo: true,
    },
  });
};

//post thread
export const postThread = (data) => {
  return trainingServe({
    url: `community/thread-controller/`,
    method: "post",
    data,
  });
};

//like a thread
export const likeThread = (data) => {
  return trainingServe({
    url: `community/thread-controller/`,
    method: "patch",
    data,
  });
};

//dislike a thread
export const dislikeThread = (data) => {
  return trainingServe({
    url: `community/thread-controller/`,
    method: "patch",
    data,
  });
};

//get comments for a thread
export const getComments = (data) => {
  return trainingServe({
    url: `community/threadcomments-controller/`,
    method: "get",
    params: {
      threadID: data.threadID,
      count: data.count,
      page: data.page,
      getCommentsInfo: true,
      searchQuery: data.searchQuery,
    },
  });
};

//post a comment
export const postComment = (data) => {
  return trainingServe({
    url: `community/threadcomments-controller/`,
    method: "post",
    data,
  });
};

//like a thread
export const likeComment = (data) => {
  return trainingServe({
    url: `community/threadcomments-controller/`,
    method: "patch",
    data,
  });
};

//dislike a thread
export const dislikeComment = (data) => {
  return trainingServe({
    url: `community/threadcomments-controller/`,
    method: "patch",
    data,
  });
};

//get replies to comments
export const getReplies = (data) => {
  return trainingServe({
    url: `community/commentsreply-controller/`,
    method: "get",
    params: {
      commentID: data.commentID,
      count: data.count,
      page: data.page,
      searchQuery: data.searchQuery,
    },
  });
};

//post a reply
export const postReply = (data) => {
  return trainingServe({
    url: `community/commentsreply-controller/`,
    method: "post",
    data,
  });
};

//like a reply
export const likeReply = (data) => {
  return trainingServe({
    url: `community/commentsreply-controller/`,
    method: "patch",
    data,
  });
};

//dislike a reply
export const dislikeReply = (data) => {
  return trainingServe({
    url: `community/commentsreply-controller/`,
    method: "patch",
    data,
  });
};

//Instructor APIs
export const getInstructorDetails = (id) => {
  return trainingServe({
    url: `marketplace/instructor-info`,
    method: "get",
    params: {
      instructorID: id,
    },
  });
};

export const getInstructorCourses = (id) => {
  return trainingServe({
    url: `marketplace/courses/`,
    method: "post",
    data: {
      instructorID: id,
      ratingSummaryInfo: "true",
      wishlistInfo: "true",
      instructorInfo: "true",
    },
  });
};

//purchase course
export const purchaseCourse = (data) => {
  return trainingServe({
    url: `candidate/course-enrollment/`,
    method: "post",
    data,
  });
};

//get popular instructors
export const getPopularInstructors = (data) => {
  return trainingServe({
    url: `marketplace/popularInstructors/`,
    method: "get",
    params: {
      page: data.page,
      count: data.count,
      searchQuery: data.searchQuery,
      order: data.order,
      sortBy: data.sortBy,
      popular: data.popular,
    },
  });
};

export const getLanguages = (data) => {
  return trainingServe({
    url: `hire3x/language-controller/`,
    method: "get",
    params: data,
  });
};

export const getPriceRange = () => {
  return trainingServe({
    url: `marketplace/price-progress/`,
    method: "get",
  });
};

export const sendReport = (data) => {
  return trainingServe({
    url: `common/report-controller/ `,
    method: "post",
    data,
  });
};

export const raiseTicket = (data) => {
  return trainingServe({
    url: `common/ticket-controller/`,
    method: "post",
    data,
  });
};

export const canRegister = () => {
  return ServiceCandidate({
    url: `can/register/`,
    method: "get",
  });
};

export const getNotificationData = (data) => {
  return notificationAuth({
    url: `notification/?project=Candidate&page=${data.page}&count=${data.count}&order=${data.order}`,
    method: "get",
    data,
    params: {
      userID: data.userID,
    },
  });
};
export const markasReadNotification = (data) => {
  return notificationAuth({
    url: `notification/`,
    method: "put",
    data,
  });
};

export const markasReadandUnreadNotification = (data) => {
  return notificationAuth({
    url: `notification/`,
    method: "put",
    data,
  });
};

export const clearNotification = (data) => {
	return notificationAuth({
		method: "delete",
		url: "/app-notification/",
		data,
    headers: {"userID": getProcessedToken()}
	});
};

export const postRegisterData = (data) =>{
  return publicService({
    url:"promotional-course/",
    method:"post",
    data
  })
}

export const postPurchaseTest = (data) => {
  return ServiceCandidate({
    url: "user/order-completion-controller/",
    method: "post",
    data,
  });
};
//etting User Preference
export const getPreference = () => {
  return prefRequest({
    url: `user-preference/`,
    method: "get",
  });
};

export const userAccess = () => {
  return SysToken({
    url: "user-access/",
    method: "get",
  });
};

export const registerCand = (data) => {
  return ServiceCandidate({
    url: "can/register/",
    method: "post",
    data,
  });
};

export const sendCandOtp = (data) => {
  return ServiceCandidate({
    url: "user/send-otp/",
    method: "post",
    data,
  });
};

export const checkAndSendOTP = (data) => {
  return ServiceCandidate({
    url: "can/check-user/",
    method: "post",
    data,
  });
};

export const checkCandOtp = (data) => {
  return ServiceCandidate({
    url: `user/check-otp/`,
    method: "get",
    params: data,
  });
};

export const resetPassword = (data) => {
  return ServiceCandidate({
    url: `user/reset-password/`,
    method: "put",
    data,
  });
};

//Email Existence Check
export const checkCandidateDirect = (params) => {
  return ServiceCandidate({
    url: "can/login/",
    method: "get",
    params, // 👈 query params
  });
};
export const getTrendingTags = (data) => {
  return ServiceCandidate({
    url: `job/global-trending/`,
    method: "get",
    params: data,
  });
};

export const getSearchSuggestions = (data) => {
  return ServiceCandidate({
    url: "/user/search-suggetion/",
    method: "get",
    params: data,
  });
};

export const googleLinkedInLogin = (data, token) => {
  return ServiceCandidate({
    url: `/can/auth/`,
    method: "post",
    data,
    headers: { Authorization: `Bearer ${token}` },
  });
};
export const postJobSearch = (data) => {
  return ServiceCandidate({
    url: "/job/job-search/",
    method: "post",
    data,
  });
};

//purchase course
export const getTrendingCourse = (data) => {
  return ServiceCandidate({
    url: `job/global-trending/`,
    method: "post",
    data,
  });
};

export const getSearchHistoryDashboard = (data) => {
  return ServiceCandidate({
    url: "/user/search-history/",
    method: "get",
    params: data,
  });
};

export const postSearchHistoryDashboard = (data) => {
  return ServiceCandidate({
    url: "/user/search-history/",
    method: "post",
    data,
  });
};

export const deleteSearchHistoryDashboard = (data) => {
  return ServiceCandidate({
    url: "/user/search-history/",
    method: "delete",
    data,
  });
};

// Anonymous Search History APIs
export const getAnonymousSearchHistory = (params) => {
  return ServiceCandidate({
    url: "/user/search-history/anonymous/",
    method: "get",
    params,
  });
};

function getProfileID() {
  return getProcessedToken();
}

export const getCandInfo = (id = null) => {
  const myId = id ? id : getProfileID();
  const params = {};
  if (myId && !myId.includes("-")) {
    params.id = myId;
  }
  return ServiceCandidate({
    url: "can/user-parser/",
    method: "get",
    params,
  });
};

export const postAnonymousSearchHistory = (data) => {
  return ServiceCandidate({
    url: "/user/search-history/anonymous/",
    method: "post",
    data,
  });
};

export const deleteAnonymousSearchHistory = (data) => {
  return ServiceCandidate({
    url: "/user/search-history/anonymous/",
    method: "delete",
    data,
  });
};

/**
 * Migration API: Sync guest search history to authenticated user account
 * Called immediately after successful login to transfer anonymous browsing history
 */
export const migrateGuestSearchHistory = async (guestUUID) => {
  return ServiceCandidate({
    url: "/user/search-history/migrate/",
    method: "post",
    headers: { userID: getProcessedToken() },
    data: { uuid: guestUUID },
  });
};

export const resumeClinic = (data) => {
  return ServiceCandidateParser({
    url: `resume-clinic/`,
    method: "post",
    data,
  });
};

// Check onboarding status - returns data._id and data.database_demographics
export const getUserParser = () => {
  return ServiceCandidate({
    url: `can/user-parser/`,
    method: "get",
  });
};
export const getCustomerFields = (data) => {
  return ServiceCandidate({
    method: "get",
    url: "common/form-config/",
    params: {
      ...data,
    },
  });
};

export const getParticularForm = (formID, id = null) => {
  return ServiceCandidate({
    method: "get",
    url: `user/forms-config`,
    params: {
      formID: formID,
      id: id ? id : getProfileID(),
    },
  });
};

export const dynamicMandetoryFields = (data, id = null) => {
  return ServiceCandidate({
    url: "user/forms-configuration/",
    method: "get",
    params: {
      experienceName: data,
      id: id ? id : getProfileID(),
    },
  });
};

export const dynamicMandetoryFieldsForNew = () => {
  return ServiceCandidate({
    url: "user/forms-configuration/",
    method: "get",
    params: {
      type: "new",
    },
  });
};

export const postCandExp = (data) => {
  return ServiceCandidate({
    url: "can/candidate-experience/",
    method: "post",
    data,
  });
};

export const postCandEdu = (data) => {
  return ServiceCandidate({
    url: "can/candidate-education/",
    method: "post",
    data,
  });
};

export const postCandInfo = (data) => {
  return ServiceCandidate({
    url: "can/candidate-information/",
    method: "post",
    data,
  });
};
export const getSuggestionCompany = (data) => {
  return requestSuggestion({
    url: "/companies/",
    method: "post",
    data,
  });
};
export const getSuggestionCollege = (data) => {
  return requestSuggestion({
    url: "/colleges/",
    method: "post",
    data,
  });
};

export const checkCandidateSignin = (data) => {
  return ServiceCandidate({
    url: "can/check-user/",
    method: "post",
    data,
  });
};

export const getCandidateOnboard = (params) => {
  return ServiceCandidate({
    url: "can/candidate-onboarding/",
    method: "get",
    params,
  });
};

export const getProfileCompletion = (userIds = "") => {
  return ServiceCandidate({
    url: "user/profile-progress/",
    method: "get",
    params: {
      id: userIds == "" ? getProfileID() : userIds,
    },
  });
};

export const resumeAnalysis = () => {
	return ServiceCandidate({
		url: "can/resume-clinic-analysis/",
		method: "GET",
	});
};
